export const setLanguage = (value) => async dispatch => {
    dispatch({ type: 'SET_LANG', lang: value });
}

export const setIsLogin = (value) => async dispatch =>{
    dispatch({type:'SET_IS_LOGIN', isLogin:value})
}


export const setUserName = (value) => async dispatch =>{
    dispatch({type:'SET_NAME', name:value})
}

export const setPhone = (value) => async dispatch =>{
    dispatch({type:'SET_PHONE', phone:value})
}